import React, { PureComponent } from 'react'
import './styles.scss'
import { withTranslation } from 'react-i18next'
import Header from '../Header'
import Footer from '../../Shared/Footer'

class DefaultLayout extends PureComponent {
  render () {
    return (
      <div className="default-layout main-wrapper">
        <Header/>
        <main>{this.props.children}</main>
        <Footer/>
      </div>
    )
  }
}

export default withTranslation()(DefaultLayout)
